import React from 'react';
import dateHelper from '../../util/dateHelper';
import { LinkV2 } from '../LinkV2';
import {
  Copyright,
  TermsList,
  TermsWrapper,
  AccessibilityImg,
} from './PreauthFooterV3Terms.styles';
import accessibilityBadge from '../../assets/images/footer/allyant-badge.svg';

const PreauthFooterV3Terms = (): JSX.Element => {
  const year = dateHelper.getFullYear();

  return (
    <TermsWrapper>
      <TermsList>
        <li>
          <LinkV2
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            subtle
            noUnderline
            inline
          >
            Privacy
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/terms" target="_blank" rel="noopener noreferrer" subtle noUnderline inline>
            Terms
          </LinkV2>
        </li>
        <li>
          <LinkV2
            href="/privacy-center"
            target="_blank"
            rel="noopener noreferrer"
            subtle
            noUnderline
            inline
          >
            Do Not Sell / Share My Personal Information
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/webaccessibility" target="_self" subtle noUnderline inline>
            Web accessibility
          </LinkV2>
        </li>
        <li>
          <LinkV2
            href="https://www.allyant.com"
            target="_blank"
            rel="noopener noreferrer"
            subtle
            noUnderline
            inline
          >
            <AccessibilityImg
              src={accessibilityBadge}
              alt="Reviewed by Allyant for accessibility stamp"
              loading="lazy"
            />
          </LinkV2>
        </li>
      </TermsList>
      <Copyright>
        &copy; <span>{year}</span> Zola, Inc. All rights reserved.
      </Copyright>
    </TermsWrapper>
  );
};

export default PreauthFooterV3Terms;
